"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var option_1 = __importDefault(require("./option"));
var core_1 = require("@material-ui/core");
var MyOptionGroup = function (props) {
    var name = props.name, selectedValue = props.selectedValue, onChange = props.onChange, selectedColor = props.selectedColor, simple = props.simple, all = props.all, label = props.label, style = props.style, options = props.options, compact = props.compact;
    var renderOptions = function (options) {
        return options.map(function (option, idx) {
            var value = typeof option.value === 'boolean'
                ? option.value
                : option.value || option.id;
            var checked = selectedValue === value;
            var id = option.id, restOption = __rest(option, ["id"]);
            return (react_1["default"].createElement(option_1["default"], __assign({ key: name + "-option-" + idx, selected: checked, onChange: onChange, selectedColor: selectedColor && checked ? selectedColor : 'black', id: "my-option-" + id }, restOption, { name: name, value: value, label: option.label || option.name, simple: simple || false })));
        });
    };
    var myOptions = all ? __spreadArrays([{ id: 0, name: 'All' }], options) : options;
    return (react_1["default"].createElement(StyledFormControl, { compact: compact ? 'compact' : undefined, style: style },
        label && (react_1["default"].createElement(StyledFormLabel, { className: "label" }, label)),
        react_1["default"].createElement("div", { className: "options" }, renderOptions(myOptions))));
};
var StyledFormControl = styled_components_1["default"](core_1.FormControl)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: ", " !important;\n\n  .label {\n    margin-right: 15px;\n  }\n\n  .options {\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: 20px;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column !important;\n\n    .label {\n      display: none;\n    }\n\n    .options {\n      margin: 0;\n    }\n  }\n"], ["\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: ",
    " !important;\n\n  .label {\n    margin-right: 15px;\n  }\n\n  .options {\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: 20px;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column !important;\n\n    .label {\n      display: none;\n    }\n\n    .options {\n      margin: 0;\n    }\n  }\n"])), function (props) {
    return props.compact ? 'flex-start' : 'space-between';
});
var StyledFormLabel = styled_components_1["default"](core_1.FormLabel)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  line-height: 47px !important;\n  width: auto;\n  float: left;\n"], ["\n  line-height: 47px !important;\n  width: auto;\n  float: left;\n"])));
exports["default"] = MyOptionGroup;
var templateObject_1, templateObject_2;
